import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgxMaskModule, IConfig } from 'ngx-mask'
import { Routes, RouterModule } from '@angular/router';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxKuvToolsModule } from 'ngx-kuv-tools';
import { NgxKuvUtilsModule } from 'ngx-kuv-utils';
import { ActualizacionStockCreateComponent } from './actualizacion-stock-create/actualizacion-stock-create.component';
import { ActualizacionStockIndexComponent } from './actualizacion-stock-index/actualizacion-stock-index.component';
import { ActualizacionStockViewComponent } from './actualizacion-stock-view/actualizacion-stock-view.component';

export const options: Partial<null|IConfig> | (() => Partial<IConfig>) = null;

const routes: Routes = [
  { path: '', redirectTo: 'index', pathMatch: 'full' },
  { path: 'index', component: ActualizacionStockIndexComponent },
];

@NgModule({
  declarations: [
    ActualizacionStockCreateComponent,
    ActualizacionStockIndexComponent,
    ActualizacionStockViewComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    ReactiveFormsModule,
    FormsModule,
    NgbModalModule,
    NgxKuvUtilsModule,
    NgxKuvToolsModule,
    NgSelectModule,
    NgxMaskModule.forRoot()
  ]
})
export class ActualizacionStockModule { }
